import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import styles from '@src/components/CameraRecord/ViewFinder.module.less';
import Countdown from '@src/components/CameraRecord/Countdown';
import { VpTeleprompterOverlay } from '@vp-ui/components/VpTeleprompterOverlay';

const ViewFinder = ({
  isCountingDown,
  stream,
  status,
  promptText,
}) => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current && stream) {
      videoRef.current.srcObject = stream;
    }
  }, [stream]);

  if (!stream || status === 'stopped') {
    return null;
  }

  if (!['idle', 'recording'].includes(status)) {
    return (
      <section className={styles.vpViewFinderContainer} />
    );
  }

  return (
    <section className={styles.vpViewFinderContainer}>
      {isCountingDown && (
        <Countdown
          className={styles.vpCountdown}
          countdownTime={3}
        />
      )}
      {status === 'recording' && (
        <div className={styles.vpRecordingIndicatorContainer}>
          <div className={styles.vpRecordingDot} />
          REC
        </div>
      )}
      <VpTeleprompterOverlay text={promptText} />
      <video
        className={styles.vpViewFinderVideo}
        ref={videoRef}
        autoPlay
      />
    </section>
  );
};

ViewFinder.propTypes = {
  isCountingDown: PropTypes.bool,
  promptText: PropTypes.string,
  status: PropTypes.string,
  stream: PropTypes.object,
};

export default ViewFinder;



// WEBPACK FOOTER //
// ./src/components/CameraRecord/ViewFinder.jsx